import { format, differenceInMinutes, addDays, subDays, startOfWeek, endOfWeek } from 'date-fns';
import { TimeEntry } from '../models/types';

export const formatDate = (date: Date): string => {
  return format(date, 'EEE MMM dd');
};

export const formatTime = (date: Date): string => {
  return format(date, 'hh:mm a');
};

export const getDayOfWeek = (date: Date): string => {
  return format(date, 'EEEE');
};

export const calculateDuration = (timeIn: Date, timeOut: Date): number => {
  return differenceInMinutes(timeOut, timeIn);
};

export const formatDuration = (minutes: number): string => {
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}:${remainingMinutes.toString().padStart(2, '0')}`;
};

const parseLunchBreakDuration = (notes: string | undefined): number => {
  if (!notes) return 0;
  const lunchBreakRegex = /Deducted (\d+) min for Lunch/gi;
  let totalLunchMinutes = 0;
  let match;
  while ((match = lunchBreakRegex.exec(notes)) !== null) {
    totalLunchMinutes += parseInt(match[1], 10);
  }
  return totalLunchMinutes;
};

export const calculateNetWorkDuration = (entry: TimeEntry): number => {
  if (!entry.timeOut) return 0;
  const grossDuration = differenceInMinutes(entry.timeOut, entry.timeIn);
  const lunchMinutes = parseLunchBreakDuration(entry.notes);
  return Math.max(0, grossDuration - lunchMinutes);
};

export const calculateDailyTotal = (entries: TimeEntry[]): number => {
  let total = 0;
  for (const entry of entries) {
    total += calculateNetWorkDuration(entry);
  }
  return total;
};

export const calculateWeeklyTotal = (entries: TimeEntry[]): number => {
  let total = 0;
  for (const entry of entries) {
    total += calculateNetWorkDuration(entry);
  }
  return total;
};

export const getNextDay = (date: Date): Date => {
  return addDays(date, 1);
};

export const getPreviousDay = (date: Date): Date => {
  return subDays(date, 1);
};

export const getWeekBounds = (date: Date): { start: Date; end: Date } => {
  return {
    start: startOfWeek(date, { weekStartsOn: 0 }),
    end: endOfWeek(date, { weekStartsOn: 0 })
  };
};

export const isToday = (date: Date): boolean => {
  const today = new Date();
  return (
    date.getDate() === today.getDate() &&
    date.getMonth() === today.getMonth() &&
    date.getFullYear() === today.getFullYear()
  );
};
